import type { SlaClock } from "@ncp/api-client";
import { useTranslation } from "@ncp/i18n";
import { SlaRing } from "@ncp/ui";

/**
 * A file's statutory period in a list: the ring and the days as one phrase. A paused period counts the days it had left when it was
 * paused, and says who paused it (7.21).
 */
export function PeriodRing({ clock, size = 26 }: { clock: SlaClock; size?: number }) {
  const { t } = useTranslation();
  const paused = clock.health === "Paused";
  const days = paused ? clock.pausedDaysLeft ?? clock.daysRemaining : clock.daysRemaining;
  return (
    <span title={paused && clock.pausedByName ? t("backoffice:cases.pausedBy", { name: clock.pausedByName }) : undefined}>
      <SlaRing size={size} percent={clock.percentElapsed} daysRemaining={days} health={clock.health} />
    </span>
  );
}
